
// The open class the component's `[&.is-open]:` variants answer to.
export const OPEN_CLASS = "is-open";

export function initMobileMenu() {
  const menu = document.getElementById("mobile-menu");
  if (!menu) return;

  const close = () => menu.classList.remove(OPEN_CLASS);

  // Every hamburger on the page toggles the same panel: the header's, and the panel's
  // own close button.
  document.querySelectorAll("[data-mobile-menu-toggle]").forEach((btn) =>
    btn.addEventListener("click", () => menu.classList.toggle(OPEN_CLASS))
  );

  menu.querySelector("[data-mobile-menu-backdrop]")?.addEventListener("click", close);
  menu.querySelectorAll("nav a").forEach((a) => a.addEventListener("click", close));

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
}
